/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCommissionStatementDtoFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, serializeDeleteCommissionStatementRequest, type CommissionStatementDto, type DeleteCommissionStatementRequest, type ErrorResponse, type InternalErrorResponse } from '../../../../models/index.js';
// @ts-ignore
import { ApproveRequestBuilderRequestsMetadata, type ApproveRequestBuilder } from './approve/index.js';
// @ts-ignore
import { DisputeRequestBuilderRequestsMetadata, type DisputeRequestBuilder } from './dispute/index.js';
// @ts-ignore
import { MarkPaidRequestBuilderRequestsMetadata, type MarkPaidRequestBuilder } from './markPaid/index.js';
// @ts-ignore
import { ReturnToReviewRequestBuilderRequestsMetadata, type ReturnToReviewRequestBuilder } from './returnToReview/index.js';
// @ts-ignore
import { SubmitForReviewRequestBuilderRequestsMetadata, type SubmitForReviewRequestBuilder } from './submitForReview/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/commissions/statements/{commissionStatementId}
 */
export interface WithCommissionStatementItemRequestBuilder extends BaseRequestBuilder<WithCommissionStatementItemRequestBuilder> {
    /**
     * The approve property
     */
    get approve(): ApproveRequestBuilder;
    /**
     * The dispute property
     */
    get dispute(): DisputeRequestBuilder;
    /**
     * The markPaid property
     */
    get markPaid(): MarkPaidRequestBuilder;
    /**
     * The returnToReview property
     */
    get returnToReview(): ReturnToReviewRequestBuilder;
    /**
     * The submitForReview property
     */
    get submitForReview(): SubmitForReviewRequestBuilder;
    /**
     * Withdraws the statement rather than destroying it: the record is kept and can still be fetched by id, but it drops out of the per-sales-rep listing. It stays in the general statements listing, so filter that on `active` to hide deleted ones. Deletion works from any status — including Paid, which nothing else can move a statement out of — and does not change the status, so a deleted statement still reads as Approved or Paid. There is no endpoint to restore one, so treat this as final from the caller's side. Deleting a statement leaves its commission plan and the underlying invoices untouched.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     delete(body: DeleteCommissionStatementRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<void>;
    /**
     * Returns one statement in full: every invoice entry with its per-line rates, the tax lines, and the complete audit trail of who moved it between statuses and when. Deleted statements are still returned here — check the `active` flag, since deletion does not change the status and a deleted statement can still read as Approved. A statement belonging to another organization reads as not found. Only preview statements are absent, as those are never stored.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CommissionStatementDto>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<WithCommissionStatementItemRequestBuilderGetQueryParameters> | undefined) : Promise<CommissionStatementDto | undefined>;
    /**
     * Withdraws the statement rather than destroying it: the record is kept and can still be fetched by id, but it drops out of the per-sales-rep listing. It stays in the general statements listing, so filter that on `active` to hide deleted ones. Deletion works from any status — including Paid, which nothing else can move a statement out of — and does not change the status, so a deleted statement still reads as Approved or Paid. There is no endpoint to restore one, so treat this as final from the caller's side. Deleting a statement leaves its commission plan and the underlying invoices untouched.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toDeleteRequestInformation(body: DeleteCommissionStatementRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * Returns one statement in full: every invoice entry with its per-line rates, the tax lines, and the complete audit trail of who moved it between statuses and when. Deleted statements are still returned here — check the `active` flag, since deletion does not change the status and a deleted statement can still read as Approved. A statement belonging to another organization reads as not found. Only preview statements are absent, as those are never stored.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<WithCommissionStatementItemRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * Returns one statement in full: every invoice entry with its per-line rates, the tax lines, and the complete audit trail of who moved it between statuses and when. Deleted statements are still returned here — check the `active` flag, since deletion does not change the status and a deleted statement can still read as Approved. A statement belonging to another organization reads as not found. Only preview statements are absent, as those are never stored.
 */
export interface WithCommissionStatementItemRequestBuilderGetQueryParameters {
    useOrganizationId?: string;
}
/**
 * Uri template for the request builder.
 */
export const WithCommissionStatementItemRequestBuilderUriTemplate = "{+baseurl}/api/commissions/statements/{commissionStatementId}{?useOrganizationId*}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const WithCommissionStatementItemRequestBuilderNavigationMetadata: Record<Exclude<keyof WithCommissionStatementItemRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    approve: {
        requestsMetadata: ApproveRequestBuilderRequestsMetadata,
    },
    dispute: {
        requestsMetadata: DisputeRequestBuilderRequestsMetadata,
    },
    markPaid: {
        requestsMetadata: MarkPaidRequestBuilderRequestsMetadata,
    },
    returnToReview: {
        requestsMetadata: ReturnToReviewRequestBuilderRequestsMetadata,
    },
    submitForReview: {
        requestsMetadata: SubmitForReviewRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const WithCommissionStatementItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    delete: {
        uriTemplate: WithCommissionStatementItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/problem+json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendNoResponseContent",
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeDeleteCommissionStatementRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
    get: {
        uriTemplate: WithCommissionStatementItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createCommissionStatementDtoFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
